import cn from 'classnames/bind';

import s from './AuthPage.module.scss';

const cx = cn.bind(s);

const AuthPage = ({
  children,
  className,
}) => {
  const wrapperClassName = cx('wrapper', className);
  return (
    <div className={cx('page')}>
      <div className={cx(wrapperClassName)}>
        {children}
      </div>
    </div>
  );
};

export default AuthPage;
